import IconButton from '@savvy-kit/components/icon-button';

import type { IconButtonProps } from '@savvy-kit/components/icon-button';
import type { TrackedClickableElementName } from '@savvy/deprecated-shared/tracking/tracked-clickable-element-name';
import { useParentElementViewContext } from '@savvy/deprecated-shared/tracking/parent-element-view-context';
import { useTrackEvent } from '@savvy/deprecated-shared/tracking/use-track-event';

export type TrackedIconButtonProps = {
  readonly elementName: TrackedClickableElementName;
} & IconButtonProps;

function TrackedIconButton({ elementName, onClick, ...props }: TrackedIconButtonProps) {
  const trackButtonClick = useTrackEvent('userInteraction');
  const parentElementViewContext = useParentElementViewContext();
  const parentElementName = parentElementViewContext?.parentElementName;
  const parentElementType = parentElementViewContext?.parentElementType;

  return (
    <IconButton
      {...props}
      onClick={(event) => {
        trackButtonClick({
          elementName,
          htmlElement: 'button',
          interactionType: 'button_click',
          parentElementName,
          parentElementType,
        });
        return onClick?.(event);
      }}
    />
  );
}

export default TrackedIconButton;
